import styled from 'styled-components'
import { Button } from 'antd'

export const StyledButton = styled(Button)`
	width: 100%;
	max-width: 424px;
	height: 48px;
	border-radius: 6px;
	font-weight: 500;
`

export const ButtonSSO = styled(Button)`
	display: flex;
	gap: 6px;
	align-items: center;
	justify-content: center;
	width: 100%;
	max-width: 424px;
	height: 48px;
	border-radius: 6px;
	font-weight: 500;
`
export const Divider = styled.div`
	width: 100%;
	font-size: 14px;
	color: gray;
	font-weight: 400;
	display: flex;
	align-items: center;

	&::before,
	&::after {
		flex: 1;
		content: '';
		height: 1px;
		background-color: #c6c6c6;
		margin: 4px;
	}
`
export const ForgotPassWrapper = styled.div`
	margin-top: 6px;
`

export const SignUpWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`

export const SignUpLink = styled(Button)`
	padding-left: 2;
	padding-right: 2;
`
